import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  useCreatePersonStudyArmAttributesMutation,
  useGetPersonStudyArmAttributesQuery,
  useGetPersonStudyArmQuery,
  useGetSitesQuery,
  useGetStudyArmConfigQuery,
  useUpdatePersonStudyArmMutation,
} from 'store/api/pkd/endpoints/studyArm';
import { openSnackbar } from 'store/application';

export const useStudyArm = (personId) => {
  const dispatch = useDispatch();

  const { site, isFetching } = useGetSitesQuery(undefined, {
    skip             : !personId,
    selectFromResult : ({ data: site, isFetching }) => ({
      site,
    }),
  });

  const { data: personStudyArm } = useGetPersonStudyArmQuery(
    { personId },
    {
      skip : !personId,
    }
  );

  const { data: personStudyArmAttributes } = useGetPersonStudyArmAttributesQuery(
    { personStudyArm: personStudyArm?.id },
    {
      skip             : !personStudyArm?.id,
      selectFromResult : ({ data = [], isLoading }) => ({
        data : data.data,
        isLoading
      })
    }
  );
  
  const { studyArm, studyArmRole, studyArmStatuses, isFetchingStudyArm } =
    useGetStudyArmConfigQuery(undefined, {
      selectFromResult : ({ data, isLoading, isFetching }) => {
        return {
          studyArm           : data?.studyArm,
          studyArmRole       : data?.studyArmRole,
          studyArmStatuses   : data?.studyArmStatuses,
          isFetchingStudyArm : isFetching,
        };
      },
    });

  const [updatePersonStudyArm, { isLoading: isPersonStudyArmUpdatring }] =
    useUpdatePersonStudyArmMutation();

  const [createPersonStudyArmAttributes, { isLoading: isCreatePersonStudyArmAttributesLoading }] = useCreatePersonStudyArmAttributesMutation();

  const handleGetStudyArmStatus = (status) => {
    return studyArmStatuses?.find(
      (studyArmStatus) => studyArmStatus.title === status
    );
  };

  const handleUpdatePersonStudyArmTable = async (status) => {
    const findStatus = handleGetStudyArmStatus(status);
    const oldStatus = Number(personStudyArm?.attributes?.studyArmStatusId);
    const newStatus = Number(findStatus?.id);

    if (!oldStatus || !newStatus || oldStatus === newStatus) {
      return;
    }

    const { error } = await updatePersonStudyArm({
      personStudyArm : personStudyArm?.id,
      attributes     : {
        studyArmStatusId : newStatus,
        studyArmRoleId   : studyArmRole?.id,
        personForWhomId  : Number(personId),
      },
    });
    if (error) {
      return dispatch(
        openSnackbar({
          type    : 'error',
          message : 'Something went wrong. Please try again',
        })
      );
    }
  };

  const handleCreatePersonStudyArmAttribute = async (person) => {
    const personStudyArmAtts = personStudyArmAttributes.map(item => item.attributes.attribute);
    const payload = person.attributes.filter(item => ['email','first_name', 'last_name'].includes(item.attribute) && !personStudyArmAtts.includes(item.attribute)).map(({ attribute, value }) => ({
      type       : 'person-study-arm-attributes',
      attributes : {
        attribute,
        value
      }
    }));
    
    if (!personStudyArmAtts.includes('enrollment_date'))
    {
      payload.push({
        type       : 'person-study-arm-attributes',
        attributes : {
          attribute : 'enrollment_date',
          value     : new Date()
        }
      });
    }
    if (payload.length > 0)
    {
      const { error } = await createPersonStudyArmAttributes({
        personStudyArm : personStudyArm?.id,
        body           : { data: payload }
      });
      if (error) {
        return dispatch(
          openSnackbar({
            type    : 'error',
            message : 'Something went wrong. Please try again',
          })
        );
      }
    }
  };

  return {
    studyArm,
    studyArmRole,
    studyArmStatuses,
    site,
    isFetchingStudyArm,
    personStudyArm,
    isPersonStudyArmUpdatring,
    isCreatePersonStudyArmAttributesLoading,
    handleGetStudyArmStatus,
    handleUpdatePersonStudyArmTable,
    handleCreatePersonStudyArmAttribute,
    
  };
};
